import React from 'react';
import styled from 'styled-components';

import Section from '@rover/kibble/patterns/Section';

const StyledSeoText = styled.div`
  font-size: ${({ theme }) => theme.paragraph['200'].fontSize};
  line-height: ${({ theme }) => theme.paragraph['200'].lineHeight};

  a {
    text-decoration: underline;
  }
`;

type SeoLocationTextProps = {
  text: string;
} & Pick<React.ComponentProps<typeof Section>, 'my' | 'mt' | 'mb'>;

const SeoLocationText: React.FC<SeoLocationTextProps> = ({ text, ...marginProps }) => (
  <Section {...marginProps}>
    <StyledSeoText
      data-qa-id="search-location-text"
      dangerouslySetInnerHTML={{
        __html: text,
      }}
    />
  </Section>
);

export default SeoLocationText;
